module.exports = __webpack_public_path__ + "static/media/JSTechRes2021-Portfolio.04fdc569.pdf";